<div class="mailing-information">
  <div class="title">Mailing Address</div>
  <form class="content" [formGroup]="form">
    <div class="form-row" *ngFor="let formField of formFields">
      <form-field [formField]="formField" [form]="form"></form-field>
    </div>
  </form>
</div>
